// @flow

import { combineReducers } from 'redux'
import UIDialogs from './reducers/UIDialogs'
import serviceReport from './reducers/reports/serviceReport'
import payrollReport from './reducers/reports/payrollReport'
import reportUIData from './reducers/reports/reportUIData'
import reportHeaders from './reducers/reports/reportHeaders'
import FirebaseTeam from './reducers/FirebaseTeam'
import calendarEvents from './reducers/firebase/calendarEvents'
import calendarDisplay from './reducers/firebase/calendarDisplay'
import gcalSettings from './reducers/gcal/gcalSettings'
import userCalendars from './reducers/gcal/userCalendars'
import userSettings from './reducers/userSettings'
import Analytics from './reducers/AnalyticsReducer'

import {
  FirebaseUser, FirebaseUserAuth, FirebaseRooms, FirebaseClockOffset, FirebaseCalendarInstances,
  ScheduleCalendarDays, ScheduleEvents
} from '@fibo-app/fibo-collab-shared'

const AppReducer = combineReducers({
  analytics: Analytics,
  uiDialogs: UIDialogs,
  schedule: combineReducers({
    events: ScheduleEvents,
    instances: FirebaseCalendarInstances
  }),
  reports: combineReducers({
    uiData: reportUIData,
    headers: reportHeaders,
    service: serviceReport,
    payroll: payrollReport
  }),
  userCalendars,
  userSettings,
  firebase: combineReducers({
    // Basic Info
    user: FirebaseUser,
    team: FirebaseTeam,
    gcal: gcalSettings,
    // Room
    rooms: FirebaseRooms,
    // Schedule
    calendarDays: ScheduleCalendarDays,
    calendarDisplay: calendarDisplay,
    calendarEvents: calendarEvents,
    // Misc
    clockOffset: FirebaseClockOffset,
    userAuth: FirebaseUserAuth
  })
})

export default AppReducer



// WEBPACK FOOTER //
// ./src/infra/AppReducer.js